import React from "react";
import Layout from "@/components/Layout";
import GradientStrip from "@/components/GradientStrip";
import QualiopiBadge from "@/components/QualiopiBadge";
import { Link } from "react-router-dom";
import { Mail, Phone, Globe, ArrowRight } from "lucide-react";

const SECTIONS = [
  {
    num: "01",
    title: "Éditeur du site",
    content: (
      <>
        <p>
          Le présent site <strong>www.wedocoaching.com</strong> est édité par :
        </p>
        <div className="mt-5 space-y-1 text-[15px] text-ink/80">
          <p><strong>WEDO COACHING & CONSEIL</strong></p>
          <p>Représentée par <strong>William Marques</strong>, fondateur et gérant</p>
          <p>Forme juridique : <strong>Société à Responsabilité Limitée (SARL)</strong></p>
          <p>SIRET : <strong>951 254 564 00010</strong></p>
          <p>SIREN : <strong>951 254 564</strong></p>
          <p>N° TVA intracommunautaire : <strong>FR36 951 254 564</strong></p>
          <p>Code NAF / APE : <strong>82.99Z</strong>  Autres activités de soutien aux entreprises n.c.a.</p>
          <p>Date de création : 03/04/2023</p>
          <p>Siège social : <strong>35 Cours Pierre Puget, 13006 Marseille, France</strong></p>
          <p className="pt-3 flex items-center gap-2"><Mail size={14}/> <a className="editorial-link" href="mailto:contact@wedocoaching.com">contact@wedocoaching.com</a></p>
          <p className="flex items-center gap-2"><Phone size={14}/> +33 6 25 48 81 83</p>
          <p className="flex items-center gap-2"><Globe size={14}/> www.wedocoaching.com</p>
        </div>
      </>
    ),
  },
  {
    num: "02",
    title: "Certification Qualiopi",
    content: (
      <>
        <p>
          WeDo Coaching & Conseil est un organisme <strong>certifié Qualiopi</strong>,
          au titre de la catégorie d'action&nbsp;: <strong>Actions de formation</strong>.
        </p>
        <p className="mt-3">
          La marque de certification Qualiopi atteste de la qualité du processus mis en œuvre
          par les prestataires concourant au développement des compétences, conformément à
          l'article L. 6316-1 du Code du travail.
        </p>
        <div className="mt-6">
          <QualiopiBadge variant="block" />
        </div>
      </>
    ),
  },
  {
    num: "03",
    title: "Directeur de la publication",
    content: (
      <p>
        Le directeur de la publication est <strong>William Marques</strong>, fondateur de WeDo Coaching & Conseil.
      </p>
    ),
  },
  {
    num: "03",
    title: "Hébergement",
    content: (
      <>
        <p>
          Le site est hébergé par <strong>Emergent Labs</strong> (Emergent.sh).
        </p>
        <p className="text-ink/55 italic mt-3 text-sm">
          [En cas de migration vers un autre hébergeur  OVHcloud, Vercel, Netlify, etc.  pensez à mettre à jour cette section.]
        </p>
      </>
    ),
  },
  {
    num: "04",
    title: "Propriété intellectuelle",
    content: (
      <>
        <p>
          L'ensemble des éléments présents sur ce site (textes, images, photographies, infographies, vidéos,
          logos, charte graphique, marque WeDo, baseline « make it matter », codes couleurs, typographies Vox et VoxWide,
          ainsi que la structure éditoriale) est la propriété exclusive de <strong>WeDo Coaching & Conseil</strong> ou
          de ses partenaires, et est protégé par le droit français et international de la propriété intellectuelle.
        </p>
        <p className="mt-4">
          Toute reproduction, représentation, modification, publication, adaptation totale ou partielle
          des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sans autorisation
          écrite préalable de WeDo Coaching & Conseil.
        </p>
        <p className="mt-4">
          Les logos et marques tiers visibles sur le site (notamment ceux des clients référencés) restent
          la propriété de leurs détenteurs respectifs et sont affichés à titre informatif.
        </p>
      </>
    ),
  },
  {
    num: "05",
    title: "Protection des données personnelles (RGPD)",
    content: (
      <>
        <p>
          Conformément au <strong>Règlement Général sur la Protection des Données (RGPD)</strong> et à la
          loi <em>Informatique et Libertés</em> du 6 janvier 1978 modifiée, les données personnelles collectées
          via le formulaire de contact et les prises de rendez-vous sont strictement nécessaires au traitement
          de votre demande.
        </p>
        <p className="mt-4">
          <strong>Données collectées :</strong> nom, prénom, adresse email, numéro de téléphone (facultatif),
          entreprise (facultatif), message.
        </p>
        <p className="mt-4">
          <strong>Finalité :</strong> répondre à votre demande, vous proposer un échange et, le cas échéant,
          vous adresser des informations utiles à votre demande d'accompagnement.
        </p>
        <p className="mt-4">
          <strong>Durée de conservation :</strong> 3 ans à compter du dernier contact actif. Les données sont
          ensuite archivées ou supprimées.
        </p>
        <p className="mt-4">
          <strong>Destinataires :</strong> uniquement WeDo Coaching & Conseil. Aucune donnée n'est cédée,
          revendue ou transférée à des tiers à des fins commerciales.
        </p>
        <p className="mt-4">
          <strong>Vos droits :</strong> vous disposez d'un droit d'accès, de rectification, d'effacement,
          de limitation, de portabilité et d'opposition au traitement de vos données. Pour exercer ces droits,
          envoyez un email à <a className="editorial-link" href="mailto:contact@wedocoaching.com">contact@wedocoaching.com</a>.
          Vous pouvez également introduire une réclamation auprès de la <strong>CNIL</strong> (www.cnil.fr).
        </p>
      </>
    ),
  },
  {
    num: "06",
    title: "Cookies",
    content: (
      <>
        <p>
          Le site www.wedocoaching.com utilise des cookies techniques strictement nécessaires à son fonctionnement
          (authentification du back-office administrateur, préférences d'affichage).
        </p>
        <p className="mt-4">
          Le site n'utilise <strong>pas</strong> de cookies publicitaires ni de cookies de traçage tiers à des
          fins de profilage marketing. Aucun consentement préalable n'est donc requis pour les cookies techniques.
        </p>
        <p className="mt-4">
          La prise de rendez-vous est gérée via un iframe <strong>Google Calendar</strong> qui peut déposer
          ses propres cookies, soumis à la politique de confidentialité de Google.
        </p>
      </>
    ),
  },
  {
    num: "07",
    title: "Limitation de responsabilité",
    content: (
      <>
        <p>
          Les informations diffusées sur le site sont fournies à titre informatif. WeDo Coaching & Conseil
          met tout en œuvre pour assurer l'exactitude et la mise à jour des contenus publiés, mais ne saurait
          être tenu responsable d'omissions, d'inexactitudes ou d'erreurs.
        </p>
        <p className="mt-4">
          L'utilisateur reconnaît utiliser ces informations sous sa responsabilité exclusive. WeDo Coaching & Conseil
          décline toute responsabilité quant aux dommages directs ou indirects résultant de l'utilisation du site
          ou de l'impossibilité d'y accéder.
        </p>
        <p className="mt-4">
          Le site peut comporter des liens hypertextes vers d'autres sites. WeDo Coaching & Conseil n'a pas
          la maîtrise de ces sites tiers et ne peut être tenu responsable de leur contenu.
        </p>
      </>
    ),
  },
  {
    num: "08",
    title: "Droit applicable",
    content: (
      <p>
        Les présentes mentions légales sont régies par le <strong>droit français</strong>. En cas de litige,
        les tribunaux français seront seuls compétents.
      </p>
    ),
  },
];

export default function Legal() {
  return (
    <Layout headerVariant="dark">
      <section data-testid="legal-hero" className="bg-brand-deep text-white pt-40 md:pt-48 pb-20">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16">
          <p className="section-num text-accent-pink fade-up">Informations légales</p>
          <h1 className="display text-5xl md:text-7xl leading-[0.95] mt-8 max-w-5xl fade-up-2">
            Mentions légales.
          </h1>
          <p className="text-white/80 text-lg leading-relaxed mt-8 max-w-3xl fade-up-3">
            Informations légales relatives au site www.wedocoaching.com, à son éditeur, à l'hébergement
            et au traitement des données personnelles.
          </p>
        </div>
        <GradientStrip />
      </section>

      <section className="bg-paper py-20 md:py-24">
        <div className="max-w-[900px] mx-auto px-6 md:px-12">
          <div className="space-y-16">
            {SECTIONS.map((s) => (
              <div key={s.num} data-testid={`legal-section-${s.num}`} className="border-l-2 border-brand pl-8 md:pl-10">
                <p className="display text-brand text-sm tracking-[0.3em]">{s.num}</p>
                <h2 className="display text-2xl md:text-3xl mt-3 leading-tight">{s.title}</h2>
                <div className="mt-6 text-[15px] leading-relaxed text-ink/85 space-y-1">
                  {s.content}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-20 pt-10 border-t border-ink/10 text-center">
            <p className="text-xs text-ink/50 uppercase tracking-wider">
              Dernière mise à jour : {new Date().toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })}
            </p>
            <Link to="/contact" data-testid="legal-cta" className="btn-pill btn-ghost mt-8 inline-flex">
              Une question ? Nous écrire <ArrowRight size={16}/>
            </Link>
          </div>
        </div>
      </section>
      <GradientStrip height="h-2"/>
    </Layout>
  );
}
